<template>
    <v-app id="inspire">
        <v-navigation-drawer
                v-model="drawer"
                app
                width="180"
                dark


        >
            <v-list-item>
                <v-list-item-content>
                    <v-list-item-title class="text-h6 " align="center">
                        TRAVEL
                    </v-list-item-title>

                </v-list-item-content>

            </v-list-item>

            <v-divider></v-divider>
            <!-- Role badge -->
            <div class="role-badge px-3 py-2">
                <v-chip x-small :color="roleColor" dark>
                    <v-icon left x-small>{{ roleIcon }}</v-icon>
                    {{ roleLabel }}
                </v-chip>
            </div>
            <v-divider></v-divider>

            <v-list shaped nav>
                <v-list-item
                        v-for="item in filteredItems1"
                        :key="$t(item.title)"
                        :to="item.to"
                        dense
                        active-class="warning"
                >
                    <v-list-item-icon>
                        <v-icon>{{ item.icon }}</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                        <v-list-item-title>{{ $t(item.title) }}</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
            </v-list>

            <v-list shaped dark nav>
                <v-list-item
                        v-for="item in filteredItems"
                        :key="$t(item.title)"
                        :to="item.to"
                        dense
                        active-class="warning"
                >
                    <v-list-item-icon>
                        <v-icon>{{ item.icon }}</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                        <v-list-item-title>{{ $t(item.title) }}</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
            </v-list>

        </v-navigation-drawer>

        <v-app-bar app flat color="green darken-4" dark height="50">
            <v-app-bar-nav-icon @click="drawer = !drawer"></v-app-bar-nav-icon>

            <v-toolbar-title>{{$t('MAIN.COMPANY_NAME')}}</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn text value="en" @click="$store.dispatch('setLang','en')">EN</v-btn>
            <v-btn text value="la" @click="$store.dispatch('setLang','la')">ລາວ</v-btn>
            <v-divider vertical class="mx-2"></v-divider>
            <v-btn icon to="/user">
                <v-icon>mdi-account</v-icon>
            </v-btn>
            <v-btn icon  @click="logout">
                <v-icon>mdi-power</v-icon>
            </v-btn>
        </v-app-bar>
        <loader-component></loader-component>
        <action-status></action-status>

        <v-main class="ma-2">
            <router-view></router-view>
        </v-main>
    </v-app>
</template>

<script>
    import ActionStatus from "@/components/actionStatus";
    import LoaderComponent from "@/components/Loader";
    export default {
        name: "MainLayout",
        components: {LoaderComponent, ActionStatus},
        data: () => ({
            drawer: null,
            // Items are tagged with `roles` — empty array means available to all roles
            items: [
                {title: 'GROUP.POLICY', icon: 'mdi-airplane-clock', to: '/travel', roles: ['user', 'admin']},
                {title: 'GROUP.SEARCH', icon: 'mdi-magnify', to: '/travel-search', roles: []},
                {title: 'GROUP.REPORT', icon: 'mdi-chart-bar', to: '/travel-report', roles: []},
                {title: 'Claims', icon: 'mdi-file-document-multiple-outline', to: '/claim', roles: []},
                {title: 'Refunds', icon: 'mdi-cash-refund', to: '/refund', roles: []},
            ],
            items1: [
                {title: 'MAIN.HOME', icon: 'mdi-view-dashboard', to: '/home', roles: []},
            ]
        }),
        computed: {
            role() {
                return this.$store.getters.userRole || 'user'
            },
            roleLabel() {
                return ({
                    admin: 'Administrator',
                    government: 'Government',
                    local_government: 'Local Government',
                    user: 'Agent'
                })[this.role] || this.role
            },
            roleIcon() {
                return ({
                    admin: 'mdi-shield-crown',
                    government: 'mdi-bank',
                    local_government: 'mdi-map-marker-radius',
                    user: 'mdi-account'
                })[this.role] || 'mdi-account'
            },
            roleColor() {
                return ({
                    admin: 'red darken-2',
                    government: 'indigo',
                    local_government: 'teal',
                    user: 'amber darken-2'
                })[this.role] || 'grey'
            },
            filteredItems() {
                return this.items.filter(i =>
                    !i.roles || i.roles.length === 0 || i.roles.includes(this.role) || this.role === 'admin'
                )
            },
            filteredItems1() {
                return this.items1.filter(i =>
                    !i.roles || i.roles.length === 0 || i.roles.includes(this.role) || this.role === 'admin'
                )
            }
        },
        methods: {
            async logout() {
                await this.$store.dispatch('logout')
            },
        }
    }
</script>

<style scoped>
    .v-application--is-ltr .v-list-item__action:first-child, .v-application--is-ltr .v-list-item__icon:first-child {
        margin-right: 15px;
    }
    .role-badge {
        text-align: center;
    }
</style>